import React from 'react';
import { LinearProgress, Box, Typography } from '@mui/material';

const variantColorMap = {
    success: '#28a745',
    danger: '#dc3545',
    warning: '#ffc107',
    info: '#17a2b8',
    primary: '#a71e3b',
};

/**
 * Componente per visualizzare la barra di avanzamento in una cella della tabella.
 */
const StatusCell = ({ variant, now, label }) => {
    const color = variantColorMap[variant] || variantColorMap.primary;

    return (
        <Box sx={{ position: 'relative', width: '100%', height: '20px' }}>
            <LinearProgress
                variant="determinate"
                value={now}
                sx={{
                    height: '20px',
                    borderRadius: '4px',
                    backgroundColor: '#e0e0e0',
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: color,
                        borderRadius: '4px',
                    },
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        color: now > 50 ? '#fff' : '#333',
                    }}
                >
                    {label}
                </Typography>
            </Box>
        </Box>
    );
};

export default StatusCell;
